import React, { useEffect, useState } from 'react';
import supabase from '../../lib/supabaseClient';

export const OWNER_ID = '83d0f7d4-2492-40ac-815a-ecc33ba0f23e';
export default function AdminSettings({ user }) {
  const owner = user.id === OWNER_ID;
  const [admins, setAdmins] = useState([]);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [failed, setFailed] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [target, setTarget] = useState(user.id);
  const [newAdminPassword, setNewAdminPassword] = useState('');
  const invoke = async payload => {
    const { data, error } = await supabase.functions.invoke('manage-admins', { body: payload });
    if (error) {
      let reason = 'ارتباط با سرور برقرار نشد. دوباره تلاش کنید.';
      try { reason = (await error.context.json()).error || reason; } catch {}
      throw new Error(reason);
    }
    if (data?.error) throw new Error(data.error);
    return data;
  };
  useEffect(() => {
    if (!owner) return;
    let active = true;
    invoke({ action: 'list' }).then(data => { if (active) setAdmins(data.admins || []); })
      .catch(err => { if (active) { setFailed(true); setMessage(err.message); } });
    return () => { active = false; };
  }, [owner]);
  const submit = async (event, action) => {
    event.preventDefault();
    if (action === 'password' && password !== confirmation) { setFailed(true); setMessage('رمز عبور و تکرار آن یکسان نیست.'); return; }
    setBusy(true); setMessage('');
    try {
      await invoke(action === 'create' ? { action, email, password: newAdminPassword } : { action, user_id: target, password });
      setFailed(false); setMessage(action === 'create' ? 'ادمین جدید ساخته شد؛ اکنون می‌تواند با ایمیل و رمز تعیین‌شده وارد شود.' : 'رمز عبور تغییر کرد.');
      if (action === 'create') { setEmail(''); setNewAdminPassword(''); setAdmins((await invoke({ action: 'list' })).admins); }
      else { setPassword(''); setConfirmation(''); }
    } catch (err) { setFailed(true); setMessage(err.message); }
    finally { setBusy(false); }
  };
  return <div className="section-settings">
    <h2 className="section-title">تنظیمات حساب و ادمین‌ها</h2>
    <div className="settings-card"><h3>{owner ? 'مدیر اصلی' : 'ادمین محتوا'}</h3><p dir="ltr">{user.email}</p></div>
    {message && <p role={failed ? 'alert' : 'status'} className={`alert ${failed ? 'alert-error' : 'alert-success'}`}>{message}</p>}
    {!owner ? <div className="settings-card"><p>تغییر رمز عبور و ساخت ادمین جدید فقط به عهده مدیر اصلی است. برای تغییر رمز خود با مدیر اصلی تماس بگیرید.</p></div> : <>
      <div className="settings-card"><h3>تغییر رمز عبور</h3>
        <form className="password-form" onSubmit={e => submit(e, 'password')}>
          <div className="form-group"><label htmlFor="admin-target">حساب ادمین</label><select id="admin-target" value={target} onChange={e => setTarget(e.target.value)} required><option value={user.id}>حساب خودم — مدیر اصلی</option>{admins.filter(a => a.user_id !== user.id).map(a => <option key={a.user_id} value={a.user_id}>{a.email}</option>)}</select></div>
          <div className="form-group"><label htmlFor="admin-new-password">رمز عبور جدید</label><input id="admin-new-password" type="password" autoComplete="new-password" dir="ltr" minLength={12} maxLength={128} required value={password} onChange={e => setPassword(e.target.value)} /></div>
          <div className="form-group"><label htmlFor="admin-confirm-password">تکرار رمز جدید</label><input id="admin-confirm-password" type="password" autoComplete="new-password" dir="ltr" required value={confirmation} onChange={e => setConfirmation(e.target.value)} /></div>
          <p className="settings-hint">رمز عبور حداقل ۱۲ کاراکتر باشد. تغییر رمز هر حساب فقط توسط مدیر اصلی انجام می‌شود.</p>
          <button className="btn-gold" disabled={busy}>ذخیره رمز جدید</button>
        </form>
      </div>
      <div className="settings-card"><h3>ساخت ادمین جدید</h3><p className="settings-hint">ادمین جدید می‌تواند مقالات را مدیریت کند؛ ساخت ادمین و تغییر رمز در اختیار مدیر اصلی می‌ماند.</p>
        <form className="password-form" onSubmit={e => submit(e, 'create')}>
          <div className="form-group"><label htmlFor="new-admin-email">ایمیل ادمین جدید</label><input id="new-admin-email" type="email" autoComplete="off" dir="ltr" required value={email} onChange={e => setEmail(e.target.value)} /></div>
          <div className="form-group"><label htmlFor="new-admin-password">رمز اولیه ادمین جدید</label><input id="new-admin-password" type="password" autoComplete="new-password" dir="ltr" minLength={12} maxLength={128} required value={newAdminPassword} onChange={e => setNewAdminPassword(e.target.value)} /></div>
          <button className="btn-gold" disabled={busy}>ساخت ادمین</button>
        </form>
      </div>
      <div className="settings-card"><h3>ادمین‌های سایت</h3>{admins.map(a => <div className="admin-account-row" key={a.user_id}><span dir="ltr">{a.email}</span><span className="badge">{a.user_id === OWNER_ID ? 'مدیر اصلی' : 'ادمین محتوا'}</span></div>)}</div>
    </>}
  </div>;
}
